import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { WebService } from '../../../services/web.service';

@Injectable({
  providedIn: 'root'
})
export class RmsTableLayoutService {
  constructor(private web: WebService) { }

  async getLayouts(layoutType?: string | null): Promise<any[]> {
    try {
      const params = layoutType ? [{ name: 'LayoutType', value: layoutType }, {name: 'UserName', value: localStorage['email'].split('@')[0]}] : [];
      const res = await lastValueFrom(this.web.getWebCall('users', '/tables', { params }));
      return Array.isArray(res) ? res : [];
    } catch (err) {
      console.warn('Failed to load table layouts', err);
      return [];
    }
  }

  async saveLayout(jsonData: string): Promise<any> {
    try {
      return await lastValueFrom(this.web.getWebCall('users', '/tables/merge', { body: JSON.parse(jsonData) }));
    } catch (err) {
      console.error('Failed to save layout', err);
      throw err;
    }
  }

  setLayout(jsonString: string, layoutType?: string | null) {
    if (!layoutType) return;
    if (localStorage[`${layoutType}TableLayout`]) {
      localStorage.removeItem(`${layoutType}TableLayout`);
    }
    console.log(`Saving ${layoutType} table layout to localStorage: ${jsonString}`);
    localStorage.setItem(`${layoutType}TableLayout`, jsonString);
  }
}
